var $0c372fcd43c2cf69$exports = {};
// Counter JS
function $0c372fcd43c2cf69$var$initializeCounter(triggerEl, counterEl) {
    const counter = document.querySelector(counterEl);
    const trigger = document.querySelector(triggerEl);
    let num = 0;
    const count = ()=>{
        num++;
        counter.innerHTML = counter.id === 'counter1' ? `${num}<span style='color:#AAC77B;'>%</span>` : `${num}<span style='color:#AAC77B;'>+</span>`;
    };
    const observer = new IntersectionObserver((entries)=>{
        if (entries[0].isIntersecting) {
            const interval = setInterval(()=>{
                if (num < counter.dataset.stop) count();
                else clearInterval(interval);
            }, counter.dataset.speed);
        }
    }, {
        threshold: [
            0
        ]
    });
    observer.observe(trigger);
}
$0c372fcd43c2cf69$var$initializeCounter("#startCounter1", "#counter");
$0c372fcd43c2cf69$var$initializeCounter("#startCounter1", "#counter1");
$0c372fcd43c2cf69$var$initializeCounter("#startCounter1", "#counter2");
window.initializeCounter = $0c372fcd43c2cf69$var$initializeCounter;


//# sourceMappingURL=about-us.04911730.js.map
